module.exports = __webpack_public_path__ + "static/media/297899.c38bdc9e.png";